import { resolveBetHouseOwnerId } from "./betHousePartners";

/** Normalize Mongo / populated refs to a comparable string id. */
export const toIdStr = (id) => {
  if (id == null) return null;
  if (typeof id === "object") return id._id?.toString?.() ?? id.toString?.();
  return String(id);
};

/** True when the user is house creator (owner) or accepted admin. */
export const isHouseOperator = (house, userId) => {
  const uid = toIdStr(userId);
  if (!house || !uid) return false;

  const inUsers = (house.users || []).some((entry) => {
    if (!["owner", "admin"].includes(String(entry.role || ""))) return false;
    if (String(entry.status || "accepted") !== "accepted") return false;
    return toIdStr(entry.userId) === uid;
  });
  if (inUsers) return true;

  return toIdStr(resolveBetHouseOwnerId(house)) === uid;
};
